import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './missed-dossiers.action';
import { MissedDossiers } from './missed-dossiers.model';

export interface MissedDossiersRecordsState {
    listData: MissedDossiers[];
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: MissedDossiersRecordsState = {
    listData: [],
    loading: false,
    error: null,
    total: 0
};

export const MissedDossiersRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);